import React from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';
import animationData from '../../assets/home-lot.json'; // Import your Lottie JSON file here

const AnimationContainer = styled.div`
  width: 100%;

  @media (max-width: 64em) {
    min-width: 40vh;
  }
`;

function CoverAnimation() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <AnimationContainer>
      <Lottie options={defaultOptions} height="100%" width="100%" />
    </AnimationContainer>
  );
}

export default CoverAnimation;
